/** @format **/

import React, { FunctionComponent } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import GridItem from '../../../components/Grid/GridItem';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import GridContainer from '../../../components/Grid/GridContainer';
import Button from '@material-ui/core/Button';
import { ReactComponent as Cancel } from '../../../assets/themes/OPL/img/icons/Cancel.svg';

type AlertDialogType = {
    open: boolean;
    titleDialog: string;
    titleDialogValueObject?: object;
    displayMessage: string;
    displayMessageValueObject?: object;
    closeCallback: () => void;
    confirmCallback: () => void;
};

export const AlertDialog: FunctionComponent<AlertDialogType> = ({
    open,
    displayMessage,
    closeCallback,
    confirmCallback,
    titleDialog,
    titleDialogValueObject,
    displayMessageValueObject,
}): React.ReactElement => {
    return (
        <Dialog open={open} onClose={closeCallback} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <GridContainer justifyContent={'space-between'}>
                    <GridItem xs={11}>
                        <h4>
                            <I18n trans={titleDialog} valueObject={titleDialogValueObject} />
                        </h4>
                    </GridItem>
                    <GridItem xs={1}>
                        <Button onClick={closeCallback} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridItem>
                </GridContainer>
            </DialogTitle>
            <DialogContent style={{minWidth: 550}}>
                <GridContainer>
                    <GridItem xs={12}>
                        {displayMessageValueObject && <I18n trans={displayMessage} valueObject={displayMessageValueObject} />}
                        {!displayMessageValueObject && <I18n trans={displayMessage} />}
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={confirmCallback} callbackParam={{}} label="general:common.ok" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
